import "./Repair.scss";

export default function Repair() {
  return (
    <section className="sales-layout__page repair">
      <h1>Reparatur</h1>
      <p>Hier werden zukünftig die Reparaturen verwaltet.</p>
    </section>
  );
}
